import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { NodeTranslator } from '../node.translator';
import { NodeAction } from '../node.action';

type IDependencies = IClientApiDependencySegment;

export const loadNodeListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOf(NodeAction.loadList.started),
  mergeMap((action) => {
    return dependencies.api.getNodeList(action.payload).pipe(
      mergeMap((response) => {
        return [
          NodeAction.loadList.done({ params: action.payload, result: { nodeList: (response.nodes ?? []).map(NodeTranslator.fromApi) } }),
        ];
      }),
      catchApiError((error) => {
        return [
          NodeAction.loadList.failed({ params: action.payload, error: undefined }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
